export const TAB_IDS = {
    SAP_RECORDS: 'sap_records',
    DRAFT: 'draft',
    PENDING: 'pending',
    RETURNED: 'returned',
    REJECTED: 'rejected',
    APPROVED: 'approved',
    ALL_GT_ORDERS: 'all_gt_orders'
};
